import { render, staticRenderFns } from "./tagGroup.vue?vue&type=template&id=a195f504"
import script from "./tagGroup.vue?vue&type=script&lang=js"
export * from "./tagGroup.vue?vue&type=script&lang=js"
import style0 from "./tagGroup.vue?vue&type=style&index=0&id=a195f504&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a195f504')) {
      api.createRecord('a195f504', component.options)
    } else {
      api.reload('a195f504', component.options)
    }
    module.hot.accept("./tagGroup.vue?vue&type=template&id=a195f504", function () {
      api.rerender('a195f504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reportForm/exportManage/tagGroup.vue"
export default component.exports